import { combineReducers } from 'redux'
import {
  addressReducer,
  breadcrumbReducer,
  loadingReducer,
  folderReducer,
  jddAddressReducer,
  personReducer,
  parcoursAddressReducer,
  deleteDocumentsReducer,
  displayValidateDocumentsReducer,
  citiesReducer,
} from './slices'

export default combineReducers({
  addressReducer,
  breadcrumbReducer,
  loadingReducer,
  folderReducer,
  jddAddressReducer,
  personReducer,
  parcoursAddressReducer,
  deleteDocumentsReducer,
  displayValidateDocumentsReducer,
  citiesReducer,
})
